import { DateUtils } from "~app/common/utils/date-utils";
import { ObjectUtils } from "~app/common/utils/object-utils";

export interface ISandningsloggSearchModel {
    sokText?: string;
    from?: string;
    tom?: string;
    maskinnummer?: string;
}

export class SandningsloggViewModel {

    constructor(private readonly model: any) {
    }

    get skickadTidpunkt() {
        if (!this.model.skickadTidpunkt) {
            return "";
        }

        return DateUtils.formatDateString(this.model.skickadTidpunkt, DateUtils.datetimeformatWithoutMillis);
    }

    get kvitteratTidpunkt() {
        if (!this.model.kvitteratTidpunkt) {
            return "";
        }

        return DateUtils.formatDateString(this.model.kvitteratTidpunkt, DateUtils.datetimeformatWithoutMillis);
    }

    get maskinId() {
        return this.model.maskinId;
    }

    get kvitteratSvar() {
        return this.model.kvitteratSvar;
    }

    get maskinnummer() {
        return this.model.maskinnummer;
    }

    get fabrikat() {
        return this.model.fabrikat;
    }

    get filnamn() {
        return this.model.filnamn;
    }

    get filskapad() {
        if (!this.model.filskapad) {
            return "";
        }

        return DateUtils.formatDateString(this.model.filskapad, DateUtils.datetimeformatWithoutMillis);
    }

    get filtyp() {
        return this.model.filtyp;
    }

    get maskintyp() {
        return this.model.maskintyp;
    }

    get sdcGpxnummer() {
        return this.model.sdcGpxnummer;
    }

    get status() {
        return this.model.status;
    }

    get version() {
        if(ObjectUtils.stringHasValue(this.model.version)) {
            return this.model.version;
        }
        return "Bifogad";
    }

    get sender() {
        if(this.model.senderApteringsfiler) {
            return "Masen";
        }
        return "XC Sender";
    }
}

export interface SandningsloggItemModel {
    kvitteratSvar: string;
    kvitteratTidpunkt: Date;
    skickadTidpunkt?: Date;
    maskinnummer: string;
    fabrikat: string;
    filnamn: string;
    filskapad: Date;
    filtyp: string;
    maskintyp: string;
    sdcGpxnummer: string;
    status: string;
    version: string;
    senderApteringsfiler: boolean;
}
